// Calendar-date fields carry no meaningful time-of-day. JSON.stringify serializes a Date via
// toISOString(), which turns local midnight into a UTC instant. Because the API returns these
// without a timezone marker, the browser reads them back as local and re-sends them as UTC, so
// every save shifted the stored value forward by the local UTC offset until the date rolled to
// the next day. Send the local calendar date instead - stable in any time zone.
const calendarDateFields = ['startDate', 'projectedEndDate', 'submissionDate', 'completionDate', 'dueDate'];

export const toLocalDateOnly = (value: any): any => {
    if (value === null || value === undefined) return value;
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return value;
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
};

// Returns a shallow copy with any calendar-date field reduced to a local yyyy-MM-dd string.
export const withCalendarDates = <T extends object>(data: T): T => {
    const payload: any = { ...data };
    calendarDateFields.forEach((field) => {
        if (field in payload) payload[field] = toLocalDateOnly(payload[field]);
    });
    return payload;
};
